"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  useActive: true,
  useEnsuredForwardedRef: true,
  useForkRef: true,
  useLiveRef: true,
  useIsScrolling: true,
  useRequestAnimationFrame: true,
  useResizeObserver: true,
  createContext: true
};
Object.defineProperty(exports, "createContext", {
  enumerable: true,
  get: function () {
    return _ContextSelector.createContext;
  }
});
Object.defineProperty(exports, "useActive", {
  enumerable: true,
  get: function () {
    return _useActive.useActive;
  }
});
Object.defineProperty(exports, "useEnsuredForwardedRef", {
  enumerable: true,
  get: function () {
    return _useEnsuredForwardedRef.useEnsuredForwardedRef;
  }
});
Object.defineProperty(exports, "useForkRef", {
  enumerable: true,
  get: function () {
    return _useForkRef.useForkRef;
  }
});
Object.defineProperty(exports, "useIsScrolling", {
  enumerable: true,
  get: function () {
    return _useIsScrolling.useIsScrolling;
  }
});
Object.defineProperty(exports, "useLiveRef", {
  enumerable: true,
  get: function () {
    return _useLiveRef.useLiveRef;
  }
});
Object.defineProperty(exports, "useRequestAnimationFrame", {
  enumerable: true,
  get: function () {
    return _useRequestAnimationFrame.useRequestAnimationFrame;
  }
});
Object.defineProperty(exports, "useResizeObserver", {
  enumerable: true,
  get: function () {
    return _useResizeObserver.useResizeObserver;
  }
});
var _useActive = require("./hooks/useActive/useActive");
var _useEnsuredForwardedRef = require("./hooks/useEnsuredForwardedRef/useEnsuredForwardedRef");
var _useForkRef = require("./hooks/useForkRef/useForkRef");
var _useLiveRef = require("./hooks/useLiveRef/useLiveRef");
var _useIsScrolling = require("./hooks/useIsScrolling/useIsScrolling");
var _useRequestAnimationFrame = require("./hooks/useRequestAnimationFrame/useRequestAnimationFrame");
var _useResizeObserver = require("./hooks/useResizeObserver/useResizeObserver");
var _callAllHandlers = require("./util/callAllHandlers");
Object.keys(_callAllHandlers).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _callAllHandlers[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _callAllHandlers[key];
    }
  });
});
var _createIsComposingHandler = require("./util/isComposing/createIsComposingHandler");
Object.keys(_createIsComposingHandler).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _createIsComposingHandler[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _createIsComposingHandler[key];
    }
  });
});
var _useIsComposingHandler = require("./util/isComposing/useIsComposingHandler");
Object.keys(_useIsComposingHandler).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _useIsComposingHandler[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useIsComposingHandler[key];
    }
  });
});
var _contains = require("./util/contains");
Object.keys(_contains).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _contains[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _contains[key];
    }
  });
});
var _focusUtil = require("./util/focusUtil");
Object.keys(_focusUtil).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _focusUtil[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _focusUtil[key];
    }
  });
});
var _genId = require("./util/genId");
Object.keys(_genId).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _genId[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _genId[key];
    }
  });
});
var _getClientId = require("./util/getClientId");
Object.keys(_getClientId).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _getClientId[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getClientId[key];
    }
  });
});
var _warnOnce = require("./util/warnOnce");
Object.keys(_warnOnce).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _warnOnce[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _warnOnce[key];
    }
  });
});
var _ContextSelector = require("./globalContextSelector/ContextSelector");
//# sourceMappingURL=index.js.map